import { supabase } from "@/integrations/supabase/client";
import { getGeo } from "@/lib/geo";

// Logs a visitor row with a synthetic "page" marker so the admin can
// describe specific actions (clicks, scrolls, etc.).
export async function trackEvent(marker: string) {
  try {
    const g = await getGeo();
    const path = window.location.pathname + window.location.search + window.location.hash;
    await supabase.from("visitors").insert({
      page: `${path}#evt=${marker}`,
      ip_address: g.ip,
      country_code: g.country_code,
      country_name: g.country_name,
      city: g.city,
      referrer: document.referrer || null,
    });
  } catch {
    // ignore
  }
}
